/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, February 24th 2022, 8:22:02 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import { APISERVICEPATHS } from "lib/api";
import { getFormConfiguration } from "lib/factories";
import { ListEditorProvider } from "lib/providers";
import { FormConfiguration } from "lib/schemas";
import { useTranslatedText } from "core";
import { FormSimpleListEditor } from "form-builder/components";
import { useServiceBuilderContext } from "service-builder/providers";

export const ServiceRegistrationFormsPage = () => {
  const LANG = useTranslatedText();
  const {
    processDefinitionContext: { currentProcessDefinition },
    removeFormFromProcessDefinition,
    updateTemplateArtifactsOnAPISaveFormConfiguration,
  } = useServiceBuilderContext();

  const onRemoveForm = React.useCallback(
    (form: FormConfiguration) => {
      removeFormFromProcessDefinition(form, "registration_form");
    },
    [removeFormFromProcessDefinition]
  );

  const onSaveFormInfo = React.useCallback(
    (updatedFormConfig: FormConfiguration) => {
      updateTemplateArtifactsOnAPISaveFormConfiguration(updatedFormConfig, "registration_form"); // Update the form type on the artifact as per the form type selected in the props, since the may need to treat the form differently from its actual form type.
    },
    [updateTemplateArtifactsOnAPISaveFormConfiguration]
  );

  const defaultNewFormConfiguration = getFormConfiguration(currentProcessDefinition.artifact_org, {
    form_type: "registration_form",
    title: "",
    login_required: true,
    sites: [currentProcessDefinition.site],
  });

  return (
    <ListEditorProvider<FormConfiguration, false>
      uniqueIdentifier="id"
      apiServicePath={APISERVICEPATHS.processDefinitions}
      apiPathParams={[currentProcessDefinition.id, "service_registration_forms"]}
      dependencyList={[currentProcessDefinition.id]}
    >
      <div className="os-service-builder-card">
        <FormSimpleListEditor
          popUpTitle="Service Registration Form Info"
          popUpDescription={
            <>
              <p>{LANG.serviceBuilderServiceFormDescription}</p>
              <p>{LANG.serviceBuilderFormInstructions}</p>
            </>
          }
          noDataMessage={LANG.serviceBuilderServiceNoData}
          form_type="registration_form"
          onRemoveForm={onRemoveForm}
          onSaveFormInfo={onSaveFormInfo}
          defaultNewFormConfiguration={defaultNewFormConfiguration}
        />
      </div>
    </ListEditorProvider>
  );
};
